import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import CoverageArea from './components/CoverageArea';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <CoverageArea />
        <Testimonials />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
